export default __webpack_public_path__ + "static/media/artist_chainsmokers.89e1df45.jpg";